import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import api from '../service/AxiosInstance';

export default function SelectSpecialite(props) {

    const { value, onChange, disabled } = props;
    const [options, setOptions] = useState([]);
    const user_connect_local = localStorage.getItem("user_connect");
    const user_connect = JSON.parse(user_connect_local);

    const tabSpec = [];

    const populate = (items) => {
        tabSpec.push({ label: 'Choisir', value: 'xxx' })

        items.map((item) => {
            if (item.codespe !== '04') {
                tabSpec.push({
                    label: item.codespe + ' - ' + item.intitule,
                    value: item.codespe
                })
            }

        })
    }

    useEffect(() => {

        api.get("Specialites/list", {
            headers: { user_id: `${user_connect.numcont}` }
        })
            .then(res => {
                populate(res.data);
                setOptions(tabSpec);
            });

    }, []);


    return (
        <div>
            <Dropdown value={value} options={options} filter onChange={onChange} disabled={disabled} placeholder="Toutes Les Spécialites" />
        </div>
    )
}
